module.exports = __webpack_public_path__ + "img/panqr3.280c7e39.jpg";